import {Component, OnInit} from '@angular/core';
import * as globals from '../../settings';

@Component({
    selector: 'app-little-about-us',
    templateUrl: './little-about-us.component.html',
    styleUrls: ['./little-about-us.component.scss']
})
export class LittleAboutUsComponent implements OnInit {
    showHiddenMessage: boolean;
    counter: any;
    brand = globals.brand;
    isMobile: boolean;

    constructor() {
        if (window.innerWidth < 991) {
            this.isMobile = true;
        } else {
            this.isMobile = false;
        }
    }

    ngOnInit() {
        this.showHiddenMessage = false;
        this.counter = 0;
    }

    count() {
        this.counter++;
        if (this.counter === 50) {
            this.showHiddenMessage = true;
        }
    }

}
